import { useEffect, useState } from 'react';
import { gardenChoice, moodForHour, nextMoodBoundary, type GardenChoice } from '../config/garden';
import { storage } from '../lib/storage';

export function useGardenMood() {
  const [choice, setChoice] = useState<GardenChoice>(() => gardenChoice(storage.get('gardenChoice')));
  const [hour, setHour] = useState(() => new Date().getHours());
  useEffect(() => { storage.set('gardenChoice', choice); }, [choice]);
  useEffect(() => {
    if (choice !== 'auto') return;
    let timer: ReturnType<typeof setTimeout>;
    const update = () => {
      clearTimeout(timer);
      const now = new Date(); setHour(now.getHours());
      timer = setTimeout(update, Math.max(1, nextMoodBoundary(now) - now.getTime() + 25));
    };
    update();
    const visible = () => { if (!document.hidden) update(); };
    document.addEventListener('visibilitychange', visible);
    window.addEventListener('focus', update);
    window.addEventListener('pageshow', update);
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', visible); window.removeEventListener('focus', update); window.removeEventListener('pageshow', update); };
  }, [choice]);
  return { choice, setChoice, mood: choice === 'auto' ? moodForHour(hour) : choice };
}
